<template>
    <div id="app">
        <router-view :key="keyScreen"/>
        <modal v-for="(m, idx) in modals"
               :key="m.id"
               :size="m.size"
               :id="m.id"
               :index="idx + 1"
               :title="m.title"
               :body="m.body"
               :buttons="m.buttons"/>

        <ModalFinancialMovement v-if="hasLogged" :key="`modalFin${hasLogged}`"/>
        <ModalMarketPlace v-if="hasLogged" :key="`modalMarketPlace${hasLogged}`"/>
        <ModalContact v-if="hasLogged" :key="`modalContact${hasLogged}`"/>
        <ModalCustomerGroupFiles v-if="hasLogged" :key="`modalGroupFiles${hasLogged}`"/>
        <ModalCustomerGroups v-if="hasLogged" :key="`modalCustGroup${hasLogged}`"/>
        <CableMonitor v-if="hasLogged" :key="`cableMonitor${hasLogged}`"/>
        <AssistantMonitor v-if="hasLogged" :key="`assistantMonitor${hasLogged}`"/>
        <PushNotification v-if="hasLogged" :key="`pushNotification${hasLogged}`"/>
        <AgribotChat v-if="hasLogged" :key="`agribotChat${hasLogged}`"/>

        <vue-snotify/>
    </div>
</template>
<script>
    import {mapMutations, mapGetters, createNamespacedHelpers} from 'vuex'
    import CableMonitor from "./components/particles/CableMonitor";
    import AssistantMonitor from "./components/particles/AssistantMonitor";
    import PushNotification from "./components/particles/PushNotification";

    const usersStore = createNamespacedHelpers('users');

    export default {
        name: "App",
        components: {
            PushNotification,
            CableMonitor,
            AssistantMonitor,
            ModalMarketPlace: () => import(/* webpackChunkName: "market-places" */ './views/market_places/ModalMarketPlace'),
            ModalFinancialMovement: () => import(/* webpackChunkName: "financial-movements" */ './views/financial_movements/ModalFinancialMovement'),
            ModalContact: () => import(/* webpackChunkName: "modal-contacts" */ './views/customers/ModalContact'),
            ModalCustomerGroupFiles: () => import(/* webpackChunkName: "modal-files" */ './views/customers/ModalCustomerGroupFiles'),
            ModalCustomerGroups: () => import(/* webpackChunkName: "modal-customer-groups" */ './views/customers/ModalCustomerGroups'),
            AgribotChat: () => import(/* webpackChunkName: "modal-customer-groups" */ './components/AgribotChat'),
        },
        data() {
            return {
                w: 0,
                h: 0
            }
        },
        methods: {
            ...mapMutations(['addModal']),
            resizeScreen() {
                this.w = window.innerWidth;
                this.h = window.innerHeight;
            }
        },
        computed: {
            ...mapGetters(['modals']),
            ...usersStore.mapGetters(['hasLogged']),
            keyScreen() {
                return `${this.w}_${this.h}`
            }
        },
        created() {
            /*if (isDevEnv())
                window.addEventListener('resize', this.resizeScreen)*/
        },
        destroyed() {
            /*if (isDevEnv())
                window.removeEventListener('resize', this.resizeScreen)*/
        }
    }
</script>
<style lang="scss">
    @import "./assets/css/styles";
</style>
